import type { BasicSprite } from "../sprites/basic_sprite"
import { centerSpriteIn } from "./center_sprite"

// Item art comes at the size it was drawn: a spear is 51px long, a dagger 11, a shard 12. At the one
// shared scale every slot used to draw them at, a dagger in a 32px slot was a six-pixel speck and
// the pack read as rows of empty sockets. The item atlas crops each icon to its art, so the frame's
// own bounds are the art's -- fit the longest side to most of the slot, without blowing small pixel
// art up past the point it turns to mush.
//
// Shared by every place an item is shown as an icon -- the pack, crafting and trade panels, the
// craft-success "+1" and the pickup count (at its own small box) -- so an item reads at one size
// everywhere.
//
// Type-only import of BasicSprite, as in center_sprite.ts, to stay clear of the sprite/renderer
// import cycle.
export const ICON_FILL = 0.8
export const ICON_MAX_SCALE = 1.5

/** The docked pack's slot, in screen pixels: the size an item is "meant" to be seen at. */
export const PACK_SLOT = 32

export const fitItemIcon = (sprite: BasicSprite, x: number, y: number, size: number) => {
    const bounds = sprite.getLocalBounds()
    const longest = Math.max(bounds.width, bounds.height)
    if (longest > 0 && isFinite(longest)) {
        // How many local units one texture pixel already takes; the cap is on the art's final scale.
        const base = Math.abs((sprite as any).sprite?.scale?.x ?? 1) || 1
        sprite.scale.set(Math.min((size * ICON_FILL) / longest, ICON_MAX_SCALE / base))
    }
    centerSpriteIn(sprite, x, y, size)
}
